<!-- header-section -->

<!--end header-section -->

<div class="container-scroller">

    <!-- header -->
    <app-header (sidebarEvent)="sidebarToggle()"></app-header>
    <!-- end header -->

    <div class="container-fluid page-body-wrapper" id="side-wrapper">

        <!-- Side Manu -->
        <!-- <div class="sidebar break-point-lg has-bg-image sidebar-wrapper" [ngClass]="openSidebar ? 'anything' : 'd-none'">
            <app-sidebar></app-sidebar>
        </div> -->
        <!--End Side Manu -->

        <!-- main-panel  -->
        <div class="main-panel">

            <!-- content-wrapper -->
            <router-outlet></router-outlet>
            <!-- end content-wrapper -->
            <!-- Footer -->
            <app-footer></app-footer>
            <!-- End Footer -->

        </div>
        <!--end main-panel -->
    </div>
    <!-- page-body-wrapper ends -->
</div>

<!-- footer-section -->

<!--end footer-section -->